import * as yup from 'yup';

/* eslint-disable */
export default yup.object().shape({
  referenciaCliente:
    yup.string('A referência deve ser textual.')
       .required('A referência é obrigatória.')
       .min(3, 'A referência deve ter no mínimo três caracteres.')
       .max(20, 'A referência pode ter no máximo vinte caracteres.')
       .trim()
       .nullable()
       .uppercase(),
  tipoImportacaoId:
    yup.number('O tipo de importação deve ser selecionado.')
       .positive('O tipo de importação deve ser positivo.')
       .nullable()
       .required('O tipo de importação é obrigatório.'),
  finalidade:
    yup.string('A finalidade deve ser selecionada.')
       .nullable()
       .required('A finalidade é obrigatória.'),
  statuus:
    yup.string().nullable(),
  importador:
    yup.string('O importador deve ser selecionado.')
       .nullable()
       .required('O importador é obrigatório.'),
  ctEmpresasCNPJ:
    yup.string('A empresa deve ser selecionada.')
       .nullable()
       .required('A empresa é obrigatória.'),
  eta:
    yup.string()
       .nullable(),
  observacao:
    yup.string()
       .max(3000, 'A observação deve ter no máximo 3000 caracteres.')
       .ensure()
       .uppercase(),
  itens:
    yup.array(yup.object().shape({
      ncm:
        yup.string()
           .required('NCM é obrigatório.')
           .nullable()
           .min(3, 'NCM deve ter no mínimo três caracteres.')
           .max(255),
      descricao:
        yup.string()
           .required('Descrição é obrigatória.')
           .nullable()
           .min(3, 'Descrição deve ter no mínimo três caracteres.')
           .uppercase(),
      codigoCliente:
        yup.string()
          .required('Código do cliente é obrigatório.')
          .label('codigoCliente')
          .uppercase(),
      codigoTrust:
          yup.string()
            .label('codigoTrust')
            .nullable(),
      unidadeMedida:
        yup.string()
           .required('Unidade de medida é obrigatória.')
           .nullable()
           .min(1, 'Unidade de medida deve ter no mínimo um caracter.')
           .max(255, 'Unidade de medida deve ter no máximo 255 caracteres.'),
      quantidade:
        yup.number()
           .required('Quantidade é obrigatória.')
           .positive()
           .nullable(),
      valorUnitario:
        yup.number()
           .required('Valor unitário é obrigatório.')
           .nullable()
           .positive(),
      moeda:
        yup.string()
           .required('Moeda é obrigatória.')
           .nullable(),
      _id:  yup.lazy(value => value ? yup.string() : yup.string().default(null).nullable().strip()),
    })).default([]),
  arquivos:
    yup.array(yup.object().shape({
      descricao:
        yup.string()
          .nullable()
          .uppercase()
          .max(255, 'Descrição deve ter no máximo 255 caracteres.'),
      tipoDocumento:
        yup.string()
           .uppercase()
           .required('Tipo de documento é obrigatório.'),
      _id: yup.lazy(value => value ? yup.string() : yup.string().default(null).nullable().strip()),
    })).default([]),
})
